import { AREAS } from "@/data/brand";
import { MapPin } from "lucide-react";

export default function AreasCovered() {
  const loop = [...AREAS, ...AREAS];
  return (
    <section
      id="areas"
      className="relative overflow-hidden border-b-2 border-black bg-black text-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-8 md:py-24">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-[var(--kay-pink)]">
              Areas Covered
            </div>
            <h2 className="font-display text-4xl uppercase leading-none sm:text-5xl md:text-6xl">
              Serving the
              <br />
              <span className="text-[var(--kay-pink)]">South West.</span>
            </h2>
          </div>
          <p className="max-w-md text-neutral-300">
            Weston-super-Mare, Somerset, Bristol, Taunton & all surrounding
            areas. Not sure if we cover you? Drop us a note when you book.
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative overflow-hidden border-y-2 border-white/20 bg-[var(--kay-pink)] py-6">
        <div className="marquee-track flex items-center gap-10 whitespace-nowrap">
          {loop.map((area, i) => (
            <div key={i} className="flex items-center gap-3">
              <MapPin size={20} className="text-black" />
              <span className="font-display text-3xl uppercase tracking-tight text-black sm:text-4xl md:text-5xl">
                {area}
              </span>
              <span className="text-black">•</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-10 text-center text-sm uppercase tracking-widest text-neutral-400 md:px-8">
        …and all surrounding areas
      </div>
    </section>
  );
}
